export const validations = {
  'Please, inform a valid email': 'Por favor, informe um email válido',
  'Please, inform a valid whatsapp number':
    'Por favor, informe um número válido de WhatsApp',
  'Please, inform both the name and surname':
    'Por favor, informe nome e sobrenome',
  'This field is required': 'Este campo é obrigatório',
};
